import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import Cookies from 'universal-cookie';

// import Button from '@material-ui/core/Button';

import AppActions from '../../actions/app-actions';
import { preformatWithRequestID } from '../../helpers';

import Loader from '../common/loader';
import UserDataEntry from './signup-steps/userdata-entry';
import OrgDataEntry from './signup-steps/orgdata-entry';
import { logout } from '../../auth';
// import { OAuth2Providers } from './oauth2providers';

class Signup extends React.Component {
  constructor(props, context) {
    super(props, context);
    let state = {
      step: 2,
      email: '',
      loading: false,
      auth0: 'false',
      password: '',
      recaptcha: '',
      formData: {}
    };

    const cookies = new Cookies();
    const auth0 = cookies.get('auth0');
    if (auth0 === 'true') {
      state.email = cookies.get('email');
      state.auth0 = auth0;
      state.step = 2;
    }
    this.state = state;
  }

  _showErrorMsg = (err, msg = '') => {
    const { body = {} } = err.res || {};
    const errormsg = body.error ? body.error.charAt(0).toUpperCase() + body.error.slice(1) 
      : 'Please check our connection';
    AppActions.setSnackbar(preformatWithRequestID(err.res, `${msg}. ${errormsg}`));
  };

  _handleStep1(formData) {
    this.setState({
      email: formData.email,
      password: formData.password_new,
      step: 2
    });
  }

  _handleSignup(formData) {
    const self = this;
    self.setState({ loading: true, formData });
    const { email, password, auth0 } = self.state;
    const credentials = auth0 === 'true' ? { email } : { email, password };
    const signup = {
      ...credentials,
      auth0: auth0 === 'true',
      tenant_name: formData.tenantName,
      tos: formData.tos,
      plan: 'enterprise',
      UUID: formData.uuid,
      marketing: formData.marketing,
      'g-recaptcha-response': formData.recaptcha || 'empty',
      deployment_type: formData.hostedBy,
      //region: formData.hostRegion,
      tenant_info: {
        address: {
          first_name: formData.firstName,
          family_name: formData.lastName,
          line1: formData.addressLine1,
          line2: formData.addressLine2,
          city: formData.city,
          country: formData.country,
          post_code: formData.postalCode
        },
        phone_number: formData.mobilePhoneNumber,
        organization: formData.organization,
      }
    };
    AppActions.createOrganizationTrial(signup)
      .then(() => {
        const cookies = new Cookies();
        cookies.remove('auth0');
        cookies.remove('email');
        self.setState({ step: 3 });

      })
      .catch(err => {
        // const state = self.state.auth0 === 'true' ? { email: '', auth0: 'false' } : { };
        self.setState({ step: 2 });
        self._showErrorMsg(err, 'Signup failed');
      })
      .finally(() => self.setState({ loading: false }));
  }

  componentDidUpdate() {
    if (this.props.currentUserId) {
      AppActions.setSnackbar('');
      this.setState({ redirectOnLogin: true });
    }
  }

  render() {
    const self = this;
    const { step, loading, redirectOnLogin } = this.state;
    if (redirectOnLogin || this.state.auth0 === 'false') {
      return <Redirect to="/" />;
    }
    return (
      <div className="full-screen">
        <div className="flexbox column" id="signup-box" style={{ margin: '16px auto' }}>
          {loading ? (
            <Loader show={true} style={{ display: 'flex' }} />
          ) : (
            <>
              <img src="assets/img/1-edgeway_logo_rgb.png" alt="loginlogo.png" className="margin-bottom-small" id="signupLogo" />
              {step == 1 && (
                <UserDataEntry
                  data={{ email: self.state.email, password: self.state.password, password_confirmation: self.state.password }}
                  onSubmit={formdata => self._handleStep1(formdata)}
                />
              )}
              {step == 2 && (
                <OrgDataEntry
                  data={this.state.formData}
                  onSubmit={(formdata) => self._handleSignup(formdata)}
                />
              )}
              {step == 3 && (
                <div className="align-center" style={{ minHeight: '50vh' }}>
                  <h1>Sign up completed</h1>
                  <h2 className="margin-bottom-large">
                    Your account has been created,
                    <br />
                    you can now log in.
                  </h2>
                  <Link style={{ marginLeft: '4px' }} to="/login">
                    Log in
                  </Link>
                </div>
              )}
              {step !== 3 && (
                <div className="flexbox margin-top" style={{ color: 'rgba(0, 0, 0, 0.3)', justifyContent: 'center' }}>
                  Already have an account?{' '}
                  <Link style={{ marginLeft: '4px' }} onClick={() => logout()} to="#">
                    Log in
                  </Link>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

export default Signup;
